module.exports = __webpack_public_path__ + "img/messages_messages-config-1.8ea3f759.jpg";